import {
    Box, Button,
    Divider,
    InputAdornment, List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    Switch,
    TextField,
    Typography
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { ColorPicker, createColor } from "material-ui-color";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProfilePic from "../../../assets/images/defaultProfile.svg";

export const BrandingControl = ({ onUpdate, value, onDelete, isPro }) => {
    const history = useNavigate();
    const [displayName, setDisplayName] = useState("");
    const [displayTitle, setDisplayTitle] = useState("");
    const [domain, setDomain] = useState("https://app.ulalive.com/");
    const [displayPhotoSrc, setDisplayPhotoSrc] = useState("");
    const [backgroundColorCode, setBackgroundColorCode] = useState("#7900F8");
    const [primaryColorCode, setPrimaryColorCode] = useState("#7900F8");
    const [secondaryColorCode, setSecondaryColorCode] = useState("#E38301");
    const [password, setPassword] = useState("");
    const [googleSignIn, setGoogleSignIn] = useState(false);
    const [showPassword, enablePassword] = useState(false);
    const [hideWatermark, enableWatermark] = useState(false);
    const [isVisible, setVisible] = useState(false);

    const handleBackgroundColorChange = (value) => {

        onUpdate(JSON.stringify({
            displayName: displayName,
            displayTitle: displayTitle,
            domain: domain,
            displayPhotoSrc: displayPhotoSrc,
            backgroundColorCode: value && "#" + value.hex,
            primaryColorCode: primaryColorCode,
            secondaryColorCode: secondaryColorCode,
            password: password,
            googleSignIn: googleSignIn,
            hideWatermark: hideWatermark,
            showPassword: showPassword
        }));
        setBackgroundColorCode(value && "#" + value.hex);
    };

    const handlePrimaryColorChange = (value) => {
        onUpdate(JSON.stringify({
            displayName: displayName,
            displayTitle: displayTitle,
            domain: domain,
            displayPhotoSrc: displayPhotoSrc,
            backgroundColorCode: backgroundColorCode,
            primaryColorCode: value && "#" + value.hex,
            secondaryColorCode: secondaryColorCode,
            password: password,
            googleSignIn: googleSignIn,
            hideWatermark: hideWatermark,
            showPassword: showPassword
        }));
        setPrimaryColorCode(value && "#" + value.hex);
    };

    const handleSecondaryColorChange = (value) => {
        onUpdate(JSON.stringify({
            displayName: displayName,
            displayTitle: displayTitle,
            domain: domain,
            displayPhotoSrc: displayPhotoSrc,
            backgroundColorCode: backgroundColorCode,
            primaryColorCode: primaryColorCode,
            secondaryColorCode: value && "#" + value.hex,
            password: password,
            googleSignIn: googleSignIn,
            hideWatermark: hideWatermark,
            showPassword: showPassword
        }));
        setSecondaryColorCode(value && "#" + value.hex);
    };

    const getColourFromCode = (value) => {
        const c = createColor(value);
        return c;
    };

    useEffect(() => {

        try {
            let val = JSON.parse(value);
            setDisplayName(val.displayName);
            setDisplayTitle(val.displayTitle);
            setDomain(val.domain);
            setDisplayPhotoSrc(val.displayPhotoSrc);
            setBackgroundColorCode(val.backgroundColorCode);
            setPrimaryColorCode(val.primaryColorCode);
            setSecondaryColorCode(val.secondaryColorCode);
            setPassword(val.password);
            setGoogleSignIn(val.googleSignIn);
            enableWatermark(val.hideWatermark);
            enablePassword(val.showPassword);
        }
        catch {

        }
    }, [value]);

    return (
        <div className='w-full mb-2'>
            {
                !isPro &&
                <Alert
                    style={{ fontSize: "0.7rem" }}
                    severity="warning"
                    action={
                        <Button
                            style={{ fontSize: "0.7rem" }}
                            size='small'
                            color="secondary"
                            onClick={() => history("/page/upgradePlan")}
                            variant="contained"
                        >
                            Upgrade Pro
                        </Button>
                    }
                >
                    Please upgrade to Pro to customize branding
                </Alert>
            }
            <div className='w-full'>
                <TextField
                    label='Display name'
                    disabled={!isPro}
                    onChange={(e) => {
                        setDisplayName(e.target.value);
                        onUpdate(JSON.stringify({
                            displayName: e.target.value,
                            displayTitle: displayTitle,
                            domain: domain,
                            displayPhotoSrc: displayPhotoSrc,
                            backgroundColorCode: backgroundColorCode,
                            primaryColorCode: primaryColorCode,
                            secondaryColorCode: secondaryColorCode,
                            password: password,
                            googleSignIn: googleSignIn,
                            hideWatermark: hideWatermark,
                            showPassword: showPassword
                        }));
                    }}
                    variant='outlined'
                    fullWidth
                    margin='dense'
                    className='my-2'
                    value={displayName}
                />
                <TextField
                    label='Display title'
                    disabled={!isPro}
                    onChange={(e) => {
                        setDisplayTitle(e.target.value);
                        onUpdate(JSON.stringify({
                            displayName: displayName,
                            displayTitle: e.target.value,
                            domain: domain,
                            displayPhotoSrc: displayPhotoSrc,
                            backgroundColorCode: backgroundColorCode,
                            primaryColorCode: primaryColorCode,
                            secondaryColorCode: secondaryColorCode,
                            password: password,
                            googleSignIn: googleSignIn,
                            hideWatermark: hideWatermark,
                            showPassword: showPassword
                        }));
                    }}
                    variant='outlined'
                    fullWidth
                    margin='dense'
                    className='my-2'
                    value={displayTitle}
                />
                <TextField
                    label='Domain'
                    disabled={!isPro}
                    onChange={(e) => {
                        setDomain(e.target.value);
                        onUpdate(JSON.stringify({
                            displayName: displayName,
                            displayTitle: displayTitle,
                            domain: e.target.value,
                            displayPhotoSrc: displayPhotoSrc,
                            backgroundColorCode: backgroundColorCode,
                            primaryColorCode: primaryColorCode,
                            secondaryColorCode: secondaryColorCode,
                            password: password,
                            googleSignIn: googleSignIn,
                            hideWatermark: hideWatermark,
                            showPassword: showPassword
                        }));
                    }}
                    variant='outlined'
                    fullWidth
                    margin='dense'
                    className='my-2'
                    value={domain}
                    InputLabelProps={{
                        shrink: true
                    }}
                    InputProps={{
                        startAdornment: <InputAdornment>
                            https://app.ulalive.com/
                        </InputAdornment>
                    }}
                />

                <List disablePadding className="border border-color-[#CECECE] p-1 rounded-lg">
                    <ListItem disableGutters>
                        <ListItemAvatar>
                            <img
                                src={displayPhotoSrc ? displayPhotoSrc : ProfilePic}
                                className="h-[48px] rounded-full pl-2 w-full"
                                alt=""
                            />
                        </ListItemAvatar>
                        <ListItemSecondaryAction>
                            <Button
                                disabled={!isPro}
                                size='small'
                                variant="contained"
                                component="label"
                            >
                                Upload File
                                <input
                                    disabled={!isPro}
                                    hidden
                                    type="file"
                                    name="banner_image"
                                    accept="image/*"
                                    onChange={(e) => {
                                        var reader = new FileReader();
                                        reader.readAsDataURL(e.target.files[0]);
                                        reader.onload = function () {
                                            setDisplayPhotoSrc(reader.result);
                                            onUpdate(JSON.stringify({
                                                displayName: displayName,
                                                displayTitle: displayTitle,
                                                domain: domain,
                                                displayPhotoSrc: reader.result,
                                                backgroundColorCode: backgroundColorCode,
                                                primaryColorCode: primaryColorCode,
                                                secondaryColorCode: secondaryColorCode,
                                                password: password,
                                                googleSignIn: googleSignIn,
                                                hideWatermark: hideWatermark,
                                                showPassword: showPassword
                                            }));
                                        };
                                        reader.onerror = function (error) {
                                            console.log('Error: ', error);
                                        };
                                    }}
                                />
                            </Button>

                        </ListItemSecondaryAction>
                    </ListItem>
                </List>



                <Box
                    display={"flex"}
                    alignItems="center"
                    width={"100%"}
                    justifyContent={"space-between"}
                    className="px-2 py-1">
                    <span className='text-gray-500'>Background Color</span>
                    <Box
                        display={"flex"}
                        alignItems="center"
                        width="120px"
                        justifyContent={isPro ? "space-between" : "center"}
                        className="border border-color-[#CECECE] p-1 rounded-lg"
                    >
                        {
                            isPro && <ColorPicker
                                hideTextfield
                                value={getColourFromCode(backgroundColorCode)}
                                onChange={handleBackgroundColorChange} />
                        }
                        <span className='text-gray-500 text-sm'>{backgroundColorCode}</span>
                    </Box>

                </Box>

                <Box
                    display={"flex"}
                    alignItems="center"
                    width={"100%"}
                    justifyContent={"space-between"}
                    className="px-2 py-1">
                    <span className='text-gray-500'>Primary Color</span>
                    <Box
                        display={"flex"}
                        width="120px"
                        alignItems="center"
                        justifyContent={isPro ? "space-between" : "center"}
                        className="border border-color-[#CECECE] p-1 rounded-lg"
                    >
                        {
                            isPro && <ColorPicker
                                disabled={isPro}
                                hideTextfield
                                value={primaryColorCode} onChange={handlePrimaryColorChange}
                            />
                        }
                        <span className='text-gray-500 text-sm'>{primaryColorCode}</span>
                    </Box>
                </Box>

                <Box
                    display={"flex"}
                    width={"100%"}
                    alignItems="center"
                    justifyContent={"space-between"}
                    className="px-2 py-1">
                    <span className='text-gray-500'>Secondary Color</span>
                    <Box
                        display={"flex"}
                        width="120px"
                        alignItems="center"
                        justifyContent={isPro ? "space-between" : "center"}
                        className="border border-color-[#CECECE] p-1 rounded-lg"
                    >
                        {
                            isPro && <ColorPicker
                                disabled={isPro}
                                hideTextfield
                                value={secondaryColorCode} onChange={handleSecondaryColorChange}
                            />
                        }
                        <span className='text-gray-500 text-sm'>{secondaryColorCode}</span>
                    </Box>
                </Box>

            </div>
            <Divider className="my-2" />
            <Typography component="p" variant="h6" className="text-gray-600 my-2">
                Privacy Settings
            </Typography>

            <Box display={"flex"} justifyContent={"space-between"} alignItems="center">
                <span className='text-gray-600  text-sm'>
                    Password protection
                </span>
                <Switch checked={showPassword} disabled={!isPro} onChange={(e) => {
                    enablePassword(e.target.checked);
                    setPassword("");
                    onUpdate(JSON.stringify({
                        displayName: displayName,
                        displayTitle: displayTitle,
                        domain: domain,
                        displayPhotoSrc: displayPhotoSrc,
                        backgroundColorCode: backgroundColorCode,
                        primaryColorCode: primaryColorCode,
                        secondaryColorCode: secondaryColorCode,
                        password: "",
                        googleSignIn: googleSignIn,
                        showPassword: e.target.checked,
                        hideWatermark: hideWatermark
                    }));
                }} />
            </Box>

            {
                showPassword && <>
                    <TextField
                        margin="dense"
                        disabled={!isPro}
                        fullWidth
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            onUpdate(JSON.stringify({
                                displayName: displayName,
                                displayTitle: displayTitle,
                                domain: domain,
                                displayPhotoSrc: displayPhotoSrc,
                                backgroundColorCode: backgroundColorCode,
                                primaryColorCode: primaryColorCode,
                                secondaryColorCode: secondaryColorCode,
                                password: e.target.value,
                                googleSignIn: googleSignIn,
                                showPassword: showPassword,
                                hideWatermark: hideWatermark
                            }));
                        }}
                        type={isVisible ? "text" : "password"}
                        InputProps={{
                            endAdornment: <InputAdornment className='text-gray-600' onClick={() => {
                                if (isPro) {
                                    setVisible(!isVisible);
                                }
                            }}>
                                {!isVisible ? <Visibility /> : <VisibilityOff />}
                            </InputAdornment>
                        }}
                        variant="outlined"
                        placeholder="Enter Password"
                    />
                </>
            }


            <Box display={"flex"} justifyContent={"space-between"} alignItems="center">
                <span className='text-gray-600  text-sm'>
                    Require Google Sign-in for response
                </span>
                <Switch checked={googleSignIn} disabled={!isPro} onChange={(e) => {
                    setGoogleSignIn(e.target.checked);
                    onUpdate(JSON.stringify({
                        displayName: displayName,
                        displayTitle: displayTitle,
                        domain: domain,
                        displayPhotoSrc: displayPhotoSrc,
                        backgroundColorCode: backgroundColorCode,
                        primaryColorCode: primaryColorCode,
                        secondaryColorCode: secondaryColorCode,
                        password: password,
                        googleSignIn: e.target.checked,
                        showPassword: showPassword,
                        hideWatermark: hideWatermark
                    }));
                }} />
            </Box>

            <Box display={"flex"} justifyContent={"space-between"} alignItems="center">
                <span className='text-gray-600  text-sm'>
                    Hide Ulalive watermark
                </span>
                <Switch checked={hideWatermark} disabled={!isPro} onChange={(e) => {
                    enableWatermark(e.target.checked);
                    onUpdate(JSON.stringify({
                        displayName: displayName,
                        displayTitle: displayTitle,
                        domain: domain,
                        displayPhotoSrc: displayPhotoSrc,
                        backgroundColorCode: backgroundColorCode,
                        primaryColorCode: primaryColorCode,
                        secondaryColorCode: secondaryColorCode,
                        password: password,
                        googleSignIn: googleSignIn,
                        hideWatermark: e.target.checked,
                        showPassword: showPassword
                    }));
                }} />
            </Box>


        </div>
    )
}
